import { API } from './redux/API';

export default API;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/API.js